var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76758 13.25C3.32133 13.25 0.517578 10.4469 0.517578 7C0.517578 3.55437 3.32133 0.75 6.76758 0.75C10.2138 0.75 13.0176 3.55375 13.0176 7C13.0176 10.4469 10.2138 13.25 6.76758 13.25ZM6.76758 2C4.0107 2 1.76758 4.24313 1.76758 7C1.76758 9.75688 4.0107 12 6.76758 12C9.52445 12 11.7676 9.75688 11.7676 7C11.7676 4.24313 9.52445 2 6.76758 2Z",
    fill: "#959595"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.39258 8.875V6.375C7.39258 6.03 7.1132 5.75 6.76758 5.75H5.51758V7H6.14258V8.875H4.89258V10.125H8.64258V8.875H7.39258Z",
    fill: "#959595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.76758 5.28125C7.19905 5.28125 7.54883 4.93147 7.54883 4.5C7.54883 4.06853 7.19905 3.71875 6.76758 3.71875C6.33611 3.71875 5.98633 4.06853 5.98633 4.5C5.98633 4.93147 6.33611 5.28125 6.76758 5.28125Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.238b31a342cd2ef32cbccdbf12d0b361.svg";
export { ForwardRef as ReactComponent };